// extracted by mini-css-extract-plugin
module.exports = {"container":"following-collaborator-container_container__A_IcG","collaboratorName":"following-collaborator-container_collaboratorName__cZO_d"};